<template>
  <div
    v-if="order.expanded && !order.loading"
    class="order-details"
  >
    <modal
      ref="deleteExamOrderModal"
      template="question"
      ref-name="deleteExamOrderModal"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      :close-button-enabled="true"
      @first-cta="closeModaldeleteExamOrder"
      @second-cta="confirmDeleteExamOrder(orderForExclusion, examForExclusion)"
    >
      <p>Deseja excluir o exame {{ examForExclusion ? examForExclusion.name : null }}?</p>
      <p v-if="examSampleSelected && examSampleSelected.collectTime && examSampleSelected.collectTime.time">
        Ao excluir um exame de curva, todos os seus tempos serão excluídos:
      </p>
      <div
        v-if="examSampleSelected && examSampleSelected.collectTime && examSampleSelected.collectTime.time"
        class="collect-time"
      >
        <template v-if="rowIndex < 19">
          <span
            v-for="(time, rowIndex) in curveLabelsToShowInExclusionDialog(examForExclusion.samples).slice(0, 20)"
            :key="rowIndex"
          >{{ time }}</span>
        </template>
        <span v-else>...</span>
      </div>
    </modal>

    <modal
      ref="deleteExamAfterTransfered"
      template="question"
      ref-name="deleteExamAfterTransfered"
      first-button-text="Cancelar"
      second-button-text="Confirmar"
      :close-button-enabled="true"
      @first-cta="closedDeleteExamAfterTransferedModal"
      @second-cta="deleteExamAfterTransfered(orderDeleteAfterTransfered)"
    >
      <p>Confirma a exclusão do exame {{ examNameToBeDeleted }} da ordem de serviço?</p>
    </modal>

    <modal
      ref="loading"
      template="loading"
      title="Aguarde"
      ref-name="loading"
    >
      <p>Salvando alterações.</p>
    </modal>

    <table class="order-details__table">
      <colgroup>
        <col class="spacement">
        <col class="cod-mnemonico">
        <col class="exams">
        <col class="samples-number">
        <col class="material">
        <col class="fixed-material">
        <col class="error">
        <col class="status">
        <col class="column-document">
        <col class="actions">
        <col class="spacement">
      </colgroup>
      <thead class="order-details__table-head">
        <tr>
          <th class="empty-column empty-column-left" />
          <th title="CÓDIGO MNEMÔNICO">
            CÓDIGO MNEMÔNICO
          </th>
          <th title="EXAME">
            EXAME
          </th>
          <th title="AMOSTRAS">
            AMOSTRAS
          </th>
          <th title="MATERIAL">
            MATERIAL
          </th>
          <th title="MATERIAL CORRIGIDO">
            MATERIAL CORRIGIDO
          </th>
          <th title="ERRO">
            ERRO
          </th>
          <th title="STATUS">
            STATUS
          </th>
          <th class="column-document" />
          <th class="column-actions" />
          <th class="empty-column empty-column-right" />
        </tr>
      </thead>

      <tbody
        v-for="(exam, rowExam) in order.exams"
        :key="rowExam"
      >
        <tr
          v-for="(sample, rowSample) in exam.samples"
          :key="rowSample"
        >
          <td class="empty-column-left" />
          <td>
            <span :title="exam.exam_sent">{{ exam.exam_sent }}</span>
          </td>
          <td>
            <span :title="getSampleExamName(sample, exam)">{{ getSampleExamName(sample, exam) }}</span>
          </td>
          <td>{{ sample.total }}</td>
          <td>
            <span :title="getMaterial(sample)">{{ getMaterial(sample) }}</span>
          </td>
          <td>
            <span :title="getFixedMaterial(sample)">{{ getFixedMaterial(sample) }}</span>
          </td>
          <td>
            <span>{{ getMessage(exam, sample) }}</span>
            <md-tooltip
              v-if="extendsMesssages(exam, sample)"
              md-delay="400"
              md-direction="top"
              class="custom-tooltip"
            >
              <h4>ERROS:</h4>
              <ul>
                <template v-if="exam.criticism_messages.length">
                  <li
                    v-for="message in exam.criticism_messages"
                    :key="message"
                  >
                    {{ message }}
                  </li>
                </template>
                <template v-if="sample.criticism_messages.length">
                  <li
                    v-for="message in sample.criticism_messages"
                    :key="message"
                  >
                    {{ message }}
                  </li>
                </template>
              </ul>
            </md-tooltip>
          </td>
          <td>
            <div class="status-container">
              <span :class="'status-symbol order-status--' + showOrderStatus(exam.status).status">•</span>
              <span :class="'status-text order-status--' + showOrderStatus(exam.status).status">{{
                showOrderStatus(exam.status).translated
              }}</span>
            </div>
          </td>
          <td class="column-document">
            <button
              v-if="toggle.userExamDocument && exam.docRequired"
              class="status-icon document-upload-button"
              :class="`document-upload-button-${exam.doc_delivered ? 'uploaded' : 'missing'}`"
              @click="redirectToDocRequiredPage()"
            >
              <svg-loader
                v-if="exam.doc_delivered"
                src="/static/images/icon-doc-button-upload-uploaded.svg"
              />
              <svg-loader
                v-else
                src="/static/images/icon-doc-button-upload-missing.svg"
              />
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                <span v-if="!exam.doc_delivered">Anexar documento(s).</span>
                <span v-else>Documento(s) já anexado(s).</span>
              </md-tooltip>
              <span>DOC</span>
            </button>
          </td>
          <td class="column-actions">
            <div
              v-if="order.state != ORDER_STATE_TRANSMITTED"
              class="order-actions"
            >
              <div
                v-if="OrderCanBeEdited(order)"
                class="status-icon icon-edit-alt"
                @click="$router.push('/orders/edit/' + order.id + '?exam=' + exam.id)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>
              <div
                v-else
                class="status-icon icon-edit-alt"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Edição não permitida
                </md-tooltip>
              </div>
              <div
                v-if="OrderCanBeExcluded(order)"
                class="status-icon icon-delete-alt details"
                @click.capture.stop="openConfirmDeleteOrder(order, exam, sample)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
              <div
                v-else
                class="status-icon icon-delete-alt icon-blocked"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Exclusão
                  <br>não permitida
                </md-tooltip>
              </div>
            </div>
            <div
              v-else-if="
                !(toggle.exam_exclusion === false || toggle.exam_exclusion === undefined) &&
                  !toggle.covax
              "
            >
              <div
                v-if="order.exams.length > 1 && order.voucher === false"
                class="status-icon icon-delete-trans"
                @click.capture.stop="openDeleteExamAfterTransferedModal(sample, order.id, exam)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
              <div
                v-else
                class="status-icon icon-delete-trans icon-blocked"
              >
                <md-tooltip
                  v-if="(order.exams.length = 1 && order.voucher === false)"
                  md-delay="400"
                  md-direction="top"
                >
                  Não é possível excluir
                  <br>o único exame da OS
                </md-tooltip>
                <md-tooltip
                  v-else
                  md-delay="400"
                  md-direction="top"
                >
                  Não é possível excluir
                  <br>exames de vouchers <br>interlaboratoriais
                </md-tooltip>
              </div>
            </div>
          </td>
          <td class="empty-column-right" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import strings from '@/strings'
import { ORDER_STATE_VALIDATED, ORDER_STATE_TRANSMITTED, ORDER_STATE_FAIL, EXAM_ORIGIN_RECOLLECT } from '@/enums'
import DocumentUploadButton from '../Documents/Laboratory/Modal/OpenModalButton'

const EXAM_COVID19_1 = 'NCOV'
const EXAM_COVID19_2 = 'COVQ'
const EXAM_COVID19_ERROR =
    'Falha na transferência: tente novamente, caso o erro persista verifique se o seu laboratório atingiu o limite máximo de envio diário para esse exame.'

export default {
  name: 'OrderDetails',
  components: {
    'document-upload-button': DocumentUploadButton
  },
  props: {
    order: Object
  },
  data: () => {
    return {
      ORDER_STATE_TRANSMITTED: ORDER_STATE_TRANSMITTED,
      examSampleSelected: null,
      examForExclusion: null,
      orderForExclusion: null,
      participantsRelationshipOptions: strings.participantsRelationship,
      isLoadingExamDelete: false,
      orderDeleteAfterTransfered: {
        orderId: null,
        sampleId: null
      },
      examNameToBeDeleted: ''
    }
  },
  computed: {
    ...mapGetters(['toggle'])
  },
  methods: {
    ...mapActions(['deleteExamOrder', 'deleteNewExamAfterTransfered', 'clearAllOrderData', 'clearAllNewOrderData']),
    showOrderStatus(status) {
      if (status) return this.$strings.orderStatus[status]
      return '-'
    },
    getSampleExamName(sample, exam) {
      if (!exam.name) {
        return 'Inválido'
      }

      var examName = exam.name

      if (sample.collectTime && sample.collectTime.time) {
        // Curve
        examName += ' - ' + sample.collectTime.time
      } else if (sample.paternity_participants && sample.paternity_participants.length > 0) {
        // Paternity
        let relationshipName =
            ' (' +
            this.participantsRelationshipOptions.filter(
              relationship => relationship.value === sample.paternity_participants[0].relationship
            )[0].label +
            ')'
        examName += ' - ' + sample.paternity_participants[0].name + relationshipName
      }

      return examName
    },
    getFixedMaterial(sample) {
      return sample.material_fixed ? sample.material_fixed : '-'
    },
    getMaterial(sample) {
      return sample.material_sent ? sample.material_sent : '-'
    },
    getMessage(exam, sample) {
      let messages = []
      if (
        (exam.exam_sent === EXAM_COVID19_1 || exam.exam_sent === EXAM_COVID19_2) &&
          this.order.state === ORDER_STATE_FAIL
      ) {
        messages.push(EXAM_COVID19_ERROR)
      } else if (exam.criticism_messages && exam.criticism_messages.length) {
        messages = exam.criticism_messages
      } else if (sample.criticism_messages && sample.criticism_messages.length) {
        messages = sample.criticism_messages
      }
      return messages && messages.length ? messages[0] : '-'
    },
    extendsMesssages(exam, sample) {
      return (
        (exam.criticism_messages && exam.criticism_messages.length) ||
          (sample.criticism_messages && sample.criticism_messages.length)
      )
    },
    openConfirmDeleteOrder(order, exam, sample) {
      this.orderForExclusion = order
      this.examSampleSelected = sample
      this.examForExclusion = exam
      this.$refs.deleteExamOrderModal.open()
    },
    confirmDeleteExamOrder(order, exam) {
      this.deleteExamOrder({ order, exam })
      this.closeModaldeleteExamOrder()
    },
    closeModaldeleteExamOrder() {
      this.$refs.deleteExamOrderModal.close()
    },
    isOrderTransmitted(order) {
      return order.state === ORDER_STATE_VALIDATED
    },
    OrderCanBeEdited(order) {
      return order.state === ORDER_STATE_VALIDATED && order.voucher === false
    },
    OrderCanBeExcluded(order) {
      return (
        order.state === ORDER_STATE_VALIDATED &&
          order.voucher === false &&
          order.exams[0].examOrigin !== EXAM_ORIGIN_RECOLLECT
      )
    },
    curveLabelsToShowInExclusionDialog(samples) {
      let curveLabels = new Set()
      samples.forEach(function (sample) {
        curveLabels.add(sample.collectTime.time)
      })
      return Array.from(curveLabels)
    },
    closedDeleteExamAfterTransferedModal() {
      this.$refs.deleteExamAfterTransfered.close()
    },
    openDeleteExamAfterTransferedModal(sample, orderId, exam) {
      this.orderDeleteAfterTransfered.orderId = orderId
      this.orderDeleteAfterTransfered.examId = exam.id
      this.$refs.deleteExamAfterTransfered.open()
      this.examNameToBeDeleted = this.getSampleExamName(sample, exam)
    },
    deleteExamAfterTransfered(order) {
      this.isLoadingExamDelete = true
      this.closedDeleteExamAfterTransferedModal()
      this.$refs.loading.open()
      this.deleteNewExamAfterTransfered(order)
        .then(response => {
          this.$refs.loading.close()
          this.refreshData()
        })
        .catch(() => {
          this.$refs.loading.close()
          this.refreshData()
        })
    },
    refreshData() {
      this.isLoadingExamDelete = false
      this.clearAllOrderData()
      this.clearAllNewOrderData()
      this.selected = []
      this.orderDeleteAfterTransfered = null
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
      }
    },
    redirectToDocRequiredPage() {
      this.$router.replace('/documentos-obrigatorios')
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';

  .order-details {
    .column-document {
      width: 8%;

      .document-upload-button {
        width: 62px;
        height: 23px;
        font-family: Roboto-bold, Roboto, sans-serif;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 12.5px;
        margin-right: 20px;
        margin-bottom: 6px;
        overflow: visible;

        .md-icon {
          position: relative;
          right: 3px;
        }

        span {
          margin: auto 6px auto 0;
        }

        &-missing {
          background-color: #fb8a00;
        }

        &-uploaded {
          background-color: #21d09b;
        }
      }
    }

    .cod-mnemonico {
      width: 7%;
    }

    .exams {
      width: 18%;
    }

    .samples-number {
      width: 10%;
    }

    .material {
      width: 10%;
    }

    .fixed-material {
      width: 10%;
    }

    .error {
      width: 10%;
    }

    .status {
      width: 10%;
    }

    .column-actions {
      width: 8%;
    }

    .spacement {
      width: 1%;
    }
    &__table {
      outline: 16px solid #fff;

      td {
        white-space: normal;
      }

      td:nth-child(4) {
        text-align: center;
      }

      tr {
        outline: none;
        height: 47px;
      }

      tr:hover {
        font-weight: bold;
        outline: none;
      }
    }

    &__table-head {
      th {
        border-bottom: 2px solid #ffffff;
        white-space: normal;
      }
    }
  }

  .empty-column {
    border-bottom: none;
  }

  .empty-column-left {
    border-left: 16px solid #fff;
  }

  .empty-column-right {
    border-right: 16px solid #fff;
  }

  .row-details-alt:hover {
    outline: none !important;
  }

  .collect-time {
    font-size: 10px;
    max-width: 300px;
    overflow: hidden;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    span {
      width: 50px;
      padding: 0;
      margin-right: 5px;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 14px;
    }
  }

  .orders-modal p {
    padding: 0 0 20px;
  }

  .modal-success-text {
    padding-bottom: 25px !important;
    padding-top: 30px !important;
  }

  .dialog-actions-small {
    width: 100%;
    height: 44px;

    .md-button {
      width: 182px;
      height: 33px;
      margin: 0px 7px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }
</style>
